import { render } from "./CaseClusterPage.vue?vue&type=template&id=0baa7da5&ts=true"
import script from "./CaseClusterPage.vue?vue&type=script&lang=ts"
export * from "./CaseClusterPage.vue?vue&type=script&lang=ts"

import "./CaseClusterPage.vue?vue&type=style&index=0&id=0baa7da5&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__